// SNKRR BAR cart drawer upsell handler
// Uses Shopify Sections API to refresh the cart drawer + bubble after AJAX add
(function(){
  'use strict';

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.snkrr-cart-upsell__btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var label = btn.querySelector('.snkrr-cart-upsell__btn-label');
    var original = label ? label.textContent : 'Add';
    btn.disabled = true;
    if (label) label.textContent = 'Adding...';

    var sectionsList = 'cart-drawer,cart-icon-bubble';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionsList.split(','),
        sections_url: window.location.pathname
      })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if (data && data.status >= 400) throw new Error(data.description || 'Add failed');

      var sections = data && data.sections ? data.sections : null;
      if (!sections) {
        return fetch(window.location.pathname + '?sections=' + sectionsList).then(function(r){ return r.json(); });
      }
      return sections;
    })
    .then(function(sections){
      if (!sections) return;

      var cartDrawer = document.querySelector('cart-drawer');
      if (sections['cart-drawer'] && cartDrawer) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.innerHTML = fresh.innerHTML;
          // Re-bind overlay close
          var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
      }

      var bubble = document.getElementById('cart-icon-bubble');
      if (sections['cart-icon-bubble'] && bubble) {
        var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshBubble = bdoc.getElementById('cart-icon-bubble');
        if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }

      if (label) label.textContent = 'Added';
      setTimeout(function(){
        // Drawer may have been replaced — find the new button if present, otherwise reset original
        if (btn.isConnected) {
          btn.disabled = false;
          if (label) label.textContent = original;
        }
      }, 1500);
    })
    .catch(function(err){
      console.error('SNKRR cart upsell error:', err);
      btn.disabled = false;
      if (label) label.textContent = original;
    });
  });
})();
